import React from "react";
import { useNavigate } from "react-router-dom";

export default function Footer() {
    const navigate = useNavigate();
    const isLoggedIn = !!localStorage.getItem("token");
    const handleContact = () => {
        if (isLoggedIn) {
            navigate("/contact");
        } else {
            window.location.href =
                "mailto:info@visionroyale.com?subject=Vision Royale Support";
        }
    };
    const handleTermsOfUse = () => navigate("/terms-of-use");
    const handlePrivacy = () => navigate("/privacy");
    return (
        <footer className="border-t border-white/10 bg-slate-950/80 absolute bottom-0 left-0 w-full">
            <div className="mx-auto max-w-7xl px-4 py-6 md:py-8 md:px-6">
            <div className="flex flex-col items-center justify-between gap-3 md:gap-4 md:flex-row">
                <div className="text-center text-xs text-white/40 md:text-left">
                © 2026 Vision Royale. AI-Powered Value Edge Engine Platform.
                </div>
                <div className="flex gap-5 md:gap-6 text-xs md:text-sm text-white/50">
                <button
                    onClick={handleTermsOfUse}
                    className="hover:text-white transition-colors"
                >
                    Terms Of Use
                </button>
                <button
                    onClick={handlePrivacy}
                    className="hover:text-white transition-colors"
                >
                    Privacy
                </button>
                <button
                    onClick={handleContact}
                    className="hover:text-white transition-colors"
                >
                    Contact
                </button>
                </div>
            </div>
            </div>
        </footer>
    );
}